import { ConcessionsApplicationOnHoldPopupQuestion } from "../interfaces/concessions-application-on-hold-popup-question.interface";

export class ConcessionsApplicationOnHoldRequest implements ConcessionsApplicationOnHoldPopupQuestion {
    constructor(
        public id: string,
        public applicationOnHoldReasonTypeId: string
    ) { }
}